// extracted by mini-css-extract-plugin
export default {"authentification":"authentification__xhkTY6"};